import { useWindowDimensions } from 'react-native';

export default (): boolean => {
  const width = useWindowDimensions().width;
  const height = useWindowDimensions().height;

  return height > width;
};
